import { useEffect, useState } from "react";
import api from "../../api";
import toast from "../../utils/toast";
import "../UserManager.css";

const BASE = "/api/insumos";

export default function InsumosCategorias() {
  const [list, setList] = useState([]);
  const [nombre, setNombre] = useState("");
  const [editando, setEditando] = useState(null);
  const [err, setErr] = useState("");

  const cargar = async () => {
    try {
      setErr("");
      const { data } = await api.get(`${BASE}/categorias`);
      setList(Array.isArray(data) ? data : []);
    } catch (e) {
      setErr(e?.response?.data?.error || e.message);
    }
  };

  useEffect(() => {
    cargar();
  }, []);

  const agregar = async () => {
    if (!nombre.trim()) return toast("Escribe el nombre de la categoría");
    try {
      await api.post(`${BASE}/categorias`, { nombre: nombre.trim() });
      setNombre("");
      cargar();
    } catch (e) {
      toast(e?.response?.data?.error || "Error al agregar");
    }
  };

  const guardarEdicion = async () => {
    if (!editando?.nombre?.trim()) return;
    try {
      await api.put(`${BASE}/categorias/${editando.id}`, { nombre: editando.nombre.trim() });
      setEditando(null);
      cargar();
    } catch (e) {
      toast(e?.response?.data?.error || "Error al actualizar");
    }
  };

  const eliminar = async (item) => {
    if (!window.confirm(`¿Eliminar categoría "${item.nombre}"?`)) return;
    try {
      await api.delete(`${BASE}/categorias/${item.id}`);
      setEditando(null);
      cargar();
    } catch (e) {
      toast(e?.response?.data?.error || "No se pudo eliminar");
    }
  };

  return (
    <div className="um-wrapper">
      <div className="um-card">
        <div className="um-header">
          <h2>Categorías de insumos</h2>
          <span className="um-badge">{list.length} categorías</span>
        </div>
        <div className="um-form" style={{ gridTemplateColumns: "1fr auto" }}>
          <div className="um-field">
            <label>Nombre</label>
            <input
              placeholder="Ej: Ingredientes"
              value={nombre}
              onChange={(e) => setNombre(e.target.value)}
            />
          </div>
          <div className="um-actions">
            <button className="um-btn um-btn-primary" onClick={agregar}>Agregar</button>
          </div>
        </div>
        {err && <div className="um-error">Error: {err}</div>}
        <div className="um-table-wrap">
          <table className="um-table">
            <thead>
              <tr>
                <th>Nombre</th>
                <th className="um-col-actions">Acciones</th>
              </tr>
            </thead>
            <tbody>
              {list.map((item) => (
                <tr key={item.id}>
                  {editando?.id === item.id ? (
                    <>
                      <td>
                        <input
                          className="um-field input"
                          value={editando.nombre}
                          onChange={(e) => setEditando({ ...editando, nombre: e.target.value })}
                        />
                      </td>
                      <td className="um-col-actions">
                        <button className="um-btn um-btn-ghost" onClick={guardarEdicion}>Guardar</button>
                        <button className="um-btn um-btn-ghost" onClick={() => setEditando(null)}>Cancelar</button>
                      </td>
                    </>
                  ) : (
                    <>
                      <td>{item.nombre}</td>
                      <td className="um-col-actions">
                        <button className="um-btn um-btn-ghost" onClick={() => setEditando({ ...item })}>Editar</button>
                        <button className="um-btn um-btn-danger" onClick={() => eliminar(item)}>Eliminar</button>
                      </td>
                    </>
                  )}
                </tr>
              ))}
              {list.length === 0 && (
                <tr><td colSpan={2} className="um-empty">No hay categorías.</td></tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
